import React from 'react';
import { Route, Routes } from 'react-router-dom';

import WorthKnowing from '@components/close-credit-account/WorthKnowing';
import CloseCreditAccountFeedback from '@components/close-credit-account/feedback/CloseCreditAccountFeedback';
import closeCreditAccountRoutes from '@components/close-credit-account/routes';
import Summary from '@components/close-credit-account/summary/Summary';
import CloseCreditAccountTransferForm from '@components/close-credit-account/transfer-form/CloseCreditAccountTransferForm';
import useText from '@hooks/use-text';

const CloseCreditAccountTransferPage = () => {
    const { closeCreditAccountTitle } = useText();

    const { feedbackUrl, worthKnowingUrl, chooseAccountUrl, summaryUrl } = closeCreditAccountRoutes;

    return (
        <div className="sgw-layout medium-centered-container">
            <div className="sgw-layout-item">
                <h3>{closeCreditAccountTitle}</h3>
                <Routes>
                    <Route path={feedbackUrl} element={<CloseCreditAccountFeedback />} />
                    <Route path={worthKnowingUrl} element={<WorthKnowing />} />
                    <Route path={chooseAccountUrl} element={<CloseCreditAccountTransferForm />} />
                    <Route path={summaryUrl} element={<Summary />} />
                </Routes>
            </div>
        </div>
    );
};

export default CloseCreditAccountTransferPage;
